import getRemBase from 'propel/getRemBase';
import throttle from 'lodash/throttle';

const blocks = document.querySelectorAll(
	'.block-icon-content .wp-block-heading--has-icon span'
);

const positionIcons = () => {
	blocks.forEach((block) => {
		const { firstChild, lastChild } = block;

		if (!block || !firstChild || !lastChild) {
			return;
		}

		block.style.removeProperty('max-width');

		const range = document.createRange();
		range.setStartBefore(firstChild);
		range.setEndAfter(lastChild);

		const { width } = range.getBoundingClientRect();

		block.style.maxWidth = `${width / getRemBase()}rem`;
	});
};

if (blocks.length > 0) {
	positionIcons();

	blocks.forEach((block) => {
		block.parentElement.classList.add('wp-block-heading--initialized');
	});

	window.addEventListener('resize', throttle(positionIcons, 100));
}
